(function ($) {
    "use strict";
    /*==============================
     Is mobile
     ==============================*/
    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    }



    /*Menu Sticky*/
    function MenuSticky() {
        if ($('#header_content').length) {
            var $this = $('#header_content'),
                size_point = $this.data().responsive,
                window_w = $(window).innerWidth(),
                window_scroll = $(window).scrollTop(),
                top_h = $('#header .header_top').innerHeight(),
                this_h = $this.innerHeight();

            if (size_point == undefined || size_point == '') {
                size_point = 1199;
            }

            if (window_scroll > top_h) {

                if (($this).hasClass('header-sticky') == false) {
                    $this.parent().addClass('header-sticky');

                    if (window_w <= size_point) {
                        $this.find('.header_menu').css('top', this_h + 'px');
                    }
                }

            } else {
                $this.parent().removeClass('header-sticky');

                if (window_w <= size_point) {
                    $this.find('.header_menu').css('top', (this_h + top_h) + 'px');
                }
            }
        }
    }

    /* Menu Resize */
    function MenuResize() {

        if ($('#header_content').length) {

            var $this = $('#header_content'),
                size_point = $this.data().responsive,
                window_scroll = $(window).scrollTop(),
                top_h = $('#header .header_top').innerHeight(),
                this_h = $this.innerHeight(),
                window_w = $(window).innerWidth();

            if (size_point == undefined || size_point == '') {
                size_point = 1199;
            }

            if (window_w <= size_point) {
                $this.addClass('header_mobile').removeClass('header_content');
            } else {
                $('.menu-bars').removeClass('active');
                $this.removeClass('header_mobile').addClass('header_content');
                $('#header_content .header_menu').css({
                    'top': ''
                }).removeClass('active').find('ul').css('display', '');
            }
        }
    }

    /* Menu Click */
    MenuBar();
    function MenuBar() {

        $('.menu-bars').on('click', function (event) {

            if ($('.header_menu').hasClass('active')) {
                $('.header_menu').removeClass('active');
                $(this).removeClass('active');
            } else {
                $('.header_menu').addClass('active');
                $(this).addClass('active');
            }

        });

        $('.menu li a').on('click', 'span', function (event) {
            event.preventDefault();

            var $this = $(this),
                $parent_li = $this.parent('a').parent('li'),
                $parent_ul = $parent_li.parent('ul');

            if ($parent_li.find('> ul').is(':hidden')) {
                $parent_ul.find('> li > ul').slideUp();
                $parent_li.find('> ul').slideDown();
            } else {
                $parent_li.find('> ul').slideUp();
            }

            return false;
        });
    }

    /*Gallery Room Detail*/
    initStaah();
    function initStaah() {
        var tmp = '';
        var defaultdate = new Date();
        $.datepicker.setDefaults({
            "closeText": "Close",
            "currentText": "Today",
            "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            prevText: '<i class="fa fa-arrow-left"></i>',
            nextText: '<i class="fa fa-arrow-right"></i>',
            "dayNames": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "dayNamesMin": ["S", "M", "T", "W", "T", "F", "S"],
            "firstDay": 1,
            "isRTL": false,
            "defaultDate": defaultdate,
            minDate: 0,
            maxDate: '+3Y',
        });
        $("#Check-in").datepicker({
            // changeMonth: true,
            numberOfMonths: 1,
            onClose: function (selectedDate) {
                debugger;
                var cSelDate = $("#Check-in").datepicker('getDate');
                if (cSelDate) {
                    cSelDate.setDate(cSelDate.getDate() + 2);
                    $("#Check-out").datepicker("option", "minDate", cSelDate);
                    $("#Check-out").focus();
                }
            },
            dateFormat: 'd M yy',
            buttonImage: '',
            buttonImageOnly: true
        });
        $("#Check-out").datepicker({
            // changeMonth: true,
            numberOfMonths: 1,
            dateFormat: 'd M yy',
            buttonImage: '',
            buttonImageOnly: true
        });
        var todaysDate = new Date();
        $("#Check-in").datepicker("setDate", todaysDate);
        var tomorrow = new Date();
        tomorrow.setDate(todaysDate.getDate() + 1);
        $("#Check-out").datepicker("setDate", +2);
    }

    /*STATISTICS Count Number*/
    StatisticsCount();
    function StatisticsCount() {
        if ($('.statistics_item .count').length) {

            var count_element = $('.count', this).html();
            $(".count", this).countTo({
                from: 0,
                to: count_element,
                speed: 2000,
                refreshInterval: 50,
            });
        }
    }

    /* Select */
    aweSelect();
    function aweSelect() {
        $('.awe-select').each(function (index, el) {
            $(this).selectpicker();
        });

    }

    /* aweCalendar */
    aweCalendar();
    function aweCalendar() {
        $('.awe-calendar').each(function () {
            var aweselect = $(this);
            aweselect.wrap('<div class="awe-calendar-wrapper"></div>');
            aweselect.after('<i class="lotus-icon-calendar"></i>');
        });
    }





    $(document).ready(function () {
        $(window).load(function () {
            // $('#preloader').delay(1000).fadeOut('400', function () {
            //     $(this).fadeOut()
            // });
            // $('body').append('<div class="awe-popup-overlay" id="awe-popup-overlay"></div><div class="awe-popup-wrap" id="awe-popup-wrap"><div class="awe-popup-content"></div><span class="awe-popup-close" id="awe-popup-close"></div>');
            // GalleryIsotope();
            // GuestBookMasonry();
            // AttractionMap();
            // ContactMap();
        });

        $(window).scroll(function (event) {
            MenuSticky();
        });

        $(window).resize(function (event) {
            // ParallaxScroll();
            // PopupCenter();
            MenuResize();
            MenuSticky();
            // AttractionClick();
        }).trigger('resize');

        $("#booknow").on("click", function () {
            debugger;
            var checkindate = $("#Check-in").val();
            var checkoutdate = $("#Check-out").val();
            var promocode = $("#promo").val() != "undefined" ? $("#promo").val() : "";
            var nguest = $("#nguest").val();

            var adultvalue = $("#roomadult").val();
            var childvalue = $("#roomchild").val();
            var chkin = changeFormat(checkindate);
            var chkout = changeFormat(checkoutdate);

            var startDay = new Date(checkindate);
            var endDay = new Date(checkoutdate);

            var millisecondsPerDay = 1000 * 60 * 60 * 24;

            var millisBetween = endDay.getTime() - startDay.getTime();
            var days = millisBetween / millisecondsPerDay;

            if (checkindate == "") {
                alert("Select check-in date");
                return false;
            } else if (checkoutdate == "") {
                alert("Select check-out date");
                return false;
            } else {
                if (document.getElementById("flexi").checked) {
                    window.open("https://staahmax.staah.net/be/indexpackdetail?propertyId=MjE1NQ==&individual=true&checkIn=" + chkin + "&checkOut=" + chkout + "&roomadult=" + adultvalue + "&roomchild=" + childvalue + "&promoCode=" + promocode, "_blank");
                }
                else {
                    window.open("https://staahmax.staah.net/be/indexpackdetail?propertyId=MjE1NQ==&individual=true&checkIn=" + checkindate + "&checkOut=" + checkoutdate + "&roomadult=" + adultvalue + "&roomchild=" + childvalue + "&promoCode=" + promocode, "_blank");
                }
            }
        });
    });

})(jQuery);

document.addEventListener('DOMContentLoaded', function () {

    let mainSlider = document.getElementById('main-slider');
    let thumbSlider = document.getElementById('main-slider');

    if (mainSlider !== null && thumbSlider !== null) {

        var main = new Splide('#main-slider', {
            type: 'fade',
            heightRatio: 0.5625,
            pagination: false,
            arrows: false,
            cover: true,
        });

        var thumbnails = new Splide('#thumbnail-slider', {
            rewind: true,
            fixedWidth: 133,
            fixedHeight: 75,
            isNavigation: true,
            gap: 10,
            focus: 'center',
            pagination: false,
            cover: true,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },
            breakpoints: {
                640: {
                    fixedWidth: 66,
                    fixedHeight: 38,
                },
            },
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
    }

});


//Staah

function changeFormat(keydate) {
    var dateObject = new Date(keydate);
    var formatedate = dateObject.getFullYear() + "-";
    formatedate += dateObject.getMonth() < 9 ? ("0" + (dateObject.getMonth() + 1) + "-") : (dateObject.getMonth() + 1) + "-";
    formatedate += dateObject.getDate() < 9 ? ("0" + dateObject.getDate()) : dateObject.getDate();
    return formatedate;
}

function booknow1() {




}